// import React from "react";
// import {
//   BsInstagram,
//   BsLink45Deg,
//   BsPinterest,
//   BsYoutube,
// } from "react-icons/bs";
// import { IoMailOutline, IoLogoTiktok } from "react-icons/io5";
// import { MdOutlinePodcasts } from "react-icons/md";
// import { FaAmazon, FaInstagram, FaLinkedin } from "react-icons/fa";
// import { StaticCompnents } from "../../../../Utils/StaticComponent";
// import { addHttpToLink } from "../../../../Utils/StayUpToDate/RenderComponent";

// const PostInfoPermalink = (props: any) => {
//   const {
//     permalink,
//     handleRedirect,
//     post_id,
//     media_url,
//     platform,
//     user_id,
//     name,
//     shop_link,
//   } = props;
  
//   // For Amazon, ShopMy, LTK, and MISC-content, check both permalink and shop_link
//   const isAffiliatePlatform = ["Amazon", "ShopMy", "LTK", "MISC-content"].includes(platform);
  
//   const hasPermalink = permalink && permalink.trim() !== "";
//   const hasShopLink = shop_link && shop_link.trim() !== "";
  
//   // For affiliate platforms, valid if either permalink or shop_link exists
//   // For other platforms, only check permalink
//   const isPermalinkValid = isAffiliatePlatform 
//     ? (hasPermalink || hasShopLink)
//     : hasPermalink;
  
//   // Determine which link to use (prefer permalink, fallback to shop_link)
//   const linkToUse = hasPermalink ? permalink : (hasShopLink ? shop_link : null);

//   const iconStyle = isPermalinkValid
//     ? { color: "#000", cursor: "pointer" }
//     : { opacity: 0.65, cursor: "not-allowed" };
//   const Icon =
//     platform === "instagram"
//       ? FaInstagram
//       : platform === "newsletter"
//       ? IoMailOutline
//       : platform === "pinterest"
//       ? BsPinterest
//       : platform === "podcast"
//       ? MdOutlinePodcasts
//       : platform === "tiktok"
//       ? IoLogoTiktok
//       : platform === "linkedin"
//       ? FaLinkedin
//       : platform === "twitter"
//       ? function TwitterIcon() {
//           return (
//             <img
//               src="/assets/icons8-twitterx-30.png"
//               alt="X (Twitter)"
//               className="social-img"
//               style={{
//                 width: "1em",
//                 height: "1em",
//                 filter: "brightness(1)",
//                 transition: "filter 0.2s",
//                 ...iconStyle,
//               }}
//               onMouseEnter={(e: any) => {
//                 e.target.style.filter = "brightness(0.6)";
//               }}
//               onMouseLeave={(e: any) => {
//                 e.target.style.filter = "brightness(1)";
//               }}
//             />
//           );
//         }
//       : platform === "youtube"
//       ? BsYoutube
//       : platform === "Amazon"
//       ? FaAmazon
//       : platform === "ShopMy"
//       ? StaticCompnents().ShopMyIcon
//       : platform === "LTK"
//       ? StaticCompnents().LTKIcon
//       : platform === "MISC-content"
//       ? function MiscContentIcon() {
//           return (
//             <></>
//             //   <img src="/assets/icons8-amazon-30.png" alt="Amazon" className="social-img" />
//           );
//         }
//       : function MiscContentIcon() {
//           return (
//             <></>
//             //   <img src="/assets/icons8-amazon-30.png" alt="Amazon" className="social-img" />
//           );
//         };

//   return (
//     <>
//       {platform ? (
//         <a
//           href={isPermalinkValid && linkToUse ? addHttpToLink(linkToUse) : undefined}
//           target="_blank"
//           rel="noreferrer"
//           style={
//             isPermalinkValid
//               ? {
//                   display: "inline-flex",
//                   alignItems: "center",
//                   verticalAlign: "middle",
//                 }
//               : {
//                   pointerEvents: "none",
//                   color: "#aaa",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   verticalAlign: "middle",
//                 }
//           }
//         >
//           {platform === "twitter" ? (
//             <Icon style={iconStyle} />
//           ) : (
//             <Icon
//               className={`bs-link`}
//               id={`${platform}-icon`}
//               style={iconStyle}
//               onMouseEnter={(e: any) => {
//                 if (isPermalinkValid) {
//                   // Find the SVG element (could be e.target, e.currentTarget, or a child)
//                   const svg = e.currentTarget.tagName === "svg" 
//                     ? e.currentTarget 
//                     : e.currentTarget.querySelector("svg") || e.target.closest("svg");
                  
//                   if (svg) {
//                     // Set color on SVG for react-icons (which use currentColor)
//                     svg.style.color = "#888";
//                     // Also update fill for custom SVG icons (ShopMy, LTK, etc.) that use CSS variables
//                     const paths = svg.querySelectorAll("path");
//                     paths.forEach((path: any) => {
//                       const fillValue = path.getAttribute("fill");
//                       // If path uses CSS variable, update fill directly
//                       if (fillValue && fillValue.includes("var(--social-icon-color)")) {
//                         path.style.fill = "#888";
//                       }
//                     });
//                   }
//                 }
//               }}
//               onMouseLeave={(e: any) => {
//                 const targetColor = isPermalinkValid ? "#000" : "#bbb";
//                 // Find the SVG element
//                 const svg = e.currentTarget.tagName === "svg" 
//                   ? e.currentTarget 
//                   : e.currentTarget.querySelector("svg") || e.target.closest("svg");
                  
//                 if (svg) {
//                   // Reset color on SVG for react-icons
//                   svg.style.color = targetColor;
//                   // Reset fill for custom SVG icons to use CSS variable again
//                   const paths = svg.querySelectorAll("path");
//                   paths.forEach((path: any) => {
//                     const fillValue = path.getAttribute("fill");
//                     if (fillValue && fillValue.includes("var(--social-icon-color)")) {
//                       path.style.fill = "";
//                     }
//                   });
//                 }
//               }}
//               onClick={() =>
//                 isPermalinkValid &&
//                 handleRedirect(post_id, media_url, platform, name, user_id)
//               }
//             />
//           )}
//         </a>
//       ) : platform === "twitter" ? (
//         <Icon style={iconStyle} />
//       ) : (
//         <Icon className="ml-6" id={`${platform}-icon`} style={iconStyle} />
//       )}
//     </>
//   );
// };

// export default PostInfoPermalink;



import React, { useCallback, useMemo } from "react";
import { BsPinterest, BsYoutube } from "react-icons/bs";
import { IoMailOutline, IoLogoTiktok } from "react-icons/io5";
import { MdOutlinePodcasts , MdPodcasts} from "react-icons/md";
import { FaAmazon, FaInstagram, FaLinkedin } from "react-icons/fa";
import { HiLink } from "react-icons/hi";
import { StaticCompnents } from "../../../../Utils/StaticComponent";
import { addHttpToLink } from "../../../../Utils/StayUpToDate/RenderComponent";
import { TwitterIcon } from "./SocialIconUtils";
import {
  normalizeShopUrl,
  resolvePlatformIconKey,
} from "../../../../Utils/normalizeShopUrl";

const LinkFallbackIcon = (props: any) => (
  <HiLink className={props.className} id={props.id} style={props.style} onClick={props.onClick} />
);

const PostInfoPermalink = (props: any) => {
  const {
    permalink,
    handleRedirect,
    post_id,
    media_url,
    platform,
    user_id,
    name,
    shop_link,
    socialIconColor,
    designTokens,
  } = props;

  const staticIcons = useMemo(() => StaticCompnents(), []);
  const iconPlatform = useMemo(
    () => resolvePlatformIconKey(platform, permalink, shop_link),
    [platform, permalink, shop_link],
  );

  const hasPermalink = useMemo(() => {
    if (typeof permalink === "string") return permalink.trim() !== "";
    return Boolean(normalizeShopUrl(permalink));
  }, [permalink]);

  const hasShopLink = useMemo(
    () => Boolean(normalizeShopUrl(shop_link)),
    [shop_link]
  );

  // Valid if permalink exists, or shop_link exists (so the icon stays clickable
  // when search RPCs omit permalink but the post is still shoppable).
  const isPermalinkValid = useMemo(() => {
    return hasPermalink || hasShopLink;
  }, [hasPermalink, hasShopLink]);

  // Prefer permalink; fallback to shop_link
  const linkToUse = useMemo(() => {
    const permalinkUrl =
      typeof permalink === "string" ? permalink.trim() : normalizeShopUrl(permalink);
    if (permalinkUrl) return permalinkUrl;
    const shopUrl = normalizeShopUrl(shop_link);
    if (shopUrl) return shopUrl;
    return null;
  }, [permalink, shop_link]);

  // Always include color for SVG icons, even when permalink is invalid
  const iconColor = socialIconColor || "#000";
  const iconStyle: React.CSSProperties = useMemo(
    () =>
      isPermalinkValid
        ? { color: iconColor, cursor: "pointer" }
        : { color: iconColor, opacity: 0.65, cursor: "not-allowed" },
      
    [isPermalinkValid, iconColor]
  );

  const Icon = useMemo(() => {
    switch (iconPlatform) {
      case "instagram":
        return FaInstagram;
      case "newsletter":
        return IoMailOutline;
      case "pinterest":
        return BsPinterest;
      case "podcast":
        return MdPodcasts;
      case "tiktok":
        return IoLogoTiktok;
      case "linkedin":
        return FaLinkedin;
      case "twitter":
        return (p: any) => <TwitterIcon iconStyle={p.style ?? iconStyle} />;
      case "youtube":
        return BsYoutube;
      case "Amazon":
        return FaAmazon;
      case "ShopMy":
        return staticIcons.ShopMyIcon;
      case "LTK":
        return staticIcons.LTKIcon;
      case "MISC":
      case "MISC-content":
        return LinkFallbackIcon;
      default:
        return LinkFallbackIcon;
    }
  }, [iconPlatform, staticIcons, iconStyle]);

  const getSvgFromEvent = (e: any) => {
    const current = e.currentTarget;
    if (!current) return null;

    if (current.tagName?.toLowerCase() === "svg") return current;

    // react-icons render an SVG, custom icon components might wrap it
    return (
      current.querySelector?.("svg") ||
      e.target?.closest?.("svg") ||
      null
    );
  };

  const setCustomSvgVarFill = (svg: SVGElement, fill: string | null) => {
    const paths = svg.querySelectorAll("path");
    paths.forEach((path: any) => {
      const fillValue = path.getAttribute("fill");
      if (fillValue && fillValue.includes("var(--social-icon-color)")) {
        path.style.fill = fill ?? "";
      }
    });
  };

  // Set fill on paths that have a visible fill (e.g. ShopMy, LTK). Skip paths with
  // fill="none" (e.g. podcast's viewport rect) so we don't turn transparent areas grey.
  const setAllPathsFill = (svg: SVGElement, fill: string) => {
    const paths = svg.querySelectorAll("path");
    paths.forEach((path: any) => {
      const pathFill = path.getAttribute("fill");
      if (pathFill === "none" || pathFill === "transparent") return;
      (path as SVGPathElement).style.fill = fill;
    });
  };

  const clearAllPathsFill = (svg: SVGElement) => {
    const paths = svg.querySelectorAll("path");
    paths.forEach((path: any) => {
      // Only clear inline fill we set; paths that had fill="none" were never set
      if ((path as SVGPathElement).style.fill) {
        (path as SVGPathElement).style.fill = "";
      }
    });
  };

  const handleMouseEnter = useCallback(
    (e: any) => {
      if (!isPermalinkValid) return;

      const svg = getSvgFromEvent(e);
      if (!svg) return;

      // react-icons uses currentColor
      (svg as any).style.color = "#888";

      // custom svgs using var(--social-icon-color)
      setCustomSvgVarFill(svg, "#888");
      // SVGs with explicit fill (e.g. ShopMy, LTK)
      setAllPathsFill(svg, "#888");
    },
    [isPermalinkValid]
  );

  const handleMouseLeave = useCallback(
    (e: any) => {
      const svg = getSvgFromEvent(e);
      if (!svg) return;

      const targetColor = isPermalinkValid ? (socialIconColor || "#000") : "#bbb";
      (svg as any).style.color = targetColor;

      // reset custom svg paths to their default (css var)
      setCustomSvgVarFill(svg, null);
      // clear inline fill so path fill attribute (e.g. ShopMy) is used again
      clearAllPathsFill(svg);
    },
    [isPermalinkValid, socialIconColor]
  );

  const onIconClick = useCallback(() => {
    if (!isPermalinkValid) return;
    handleRedirect(post_id, media_url, platform, name, user_id);
  }, [
    isPermalinkValid,
    handleRedirect,
    post_id,
    media_url,
    platform,
    name,
    user_id,
  ]);

  const anchorStyle: React.CSSProperties = useMemo(
    () =>
      isPermalinkValid
        ? {
            display: "inline-flex",
            alignItems: "center",
            verticalAlign: "middle",
          }
        : {
            pointerEvents: "none",
            color: "#aaa",
            display: "inline-flex",
            alignItems: "center",
            verticalAlign: "middle",
          },
    [isPermalinkValid]
  );

  if (!iconPlatform) {
    return null;
  }

  return (
    <a
      href={isPermalinkValid && linkToUse ? addHttpToLink(linkToUse) : undefined}
      target="_blank"
      rel="noreferrer"
      style={anchorStyle}
    >
      {iconPlatform === "twitter" ? (
        <Icon style={iconStyle} />
      ) : (
        <Icon
          className="bs-link"
          id={`${iconPlatform}-icon`}
          style={iconStyle}
          onClick={onIconClick}
        />
      )}
    </a>
  );
};

export default PostInfoPermalink;
